import Faq from 'components/Common/Faq'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import Heading from 'LuxKit/Typography/Heading'
import { useIntl } from 'react-intl'

function LuxPlusMonthLandingPageFaq() {
  const intl = useIntl()

  return <Sheet padding="64 0">
    <LayoutContainer variant="medium">
      <Group direction="vertical" gap={24}>
        <Heading variant="heading3" align="center" as="h2">{intl.formatMessage({
          id: 'CxXbpv4A8H_HPAgw4wgp',
          defaultMessage: 'Frequently Asked Questions',
          description: 'FAQ section heading on LuxPlus+ Month landing page',
        })}
        </Heading>
        <Faq slug="luxplus-faqs" />
      </Group>
    </LayoutContainer>
  </Sheet>
}

export default LuxPlusMonthLandingPageFaq
